import React from 'react'
import { containsInvalidValue } from './containsInvalidValue'
import { validContact } from '../../../../../utilities/methods/validContact'

export const ContactDetailsInfo = ({ errors, touched, values }) => {
  const { anonymous_acknowledgement } = values

  const isValidContact = validContact(values)

  const isTouched = arr => {
    const touchedValues = arr.filter(i => touched.hasOwnProperty(i))
    return touchedValues.length !== 0
  }

  const isValidName = !containsInvalidValue(
    ['first_name', 'last_name'],
    errors,
    touched
  )
  const isContactTouched = isTouched([
    'email',
    'work_email',
    'home_phone',
    'cell_phone',
    'work_phone',
    'address',
    'city',
    'state',
    'zip'
  ])
  const anon = anonymous_acknowledgement[0] === 'Yes'

  return (
    <React.Fragment>
      <h2 className="ds-u-margin-bottom--0">Your contact information</h2>
      {!anon && isValidName && isContactTouched && !isValidContact && (
        <p className="ds-u-color--error ds-u-margin-bottom--0">
          You must either provide a phone number and an email address, or your
          complete home address.
        </p>
      )}
    </React.Fragment>
  )
}
